import { getShipiumBaseHost, getShipiumDomain } from '~/utils/shipiumDomain';

const getGatewayUri = () => {
  const isProd = process.env.NODE_ENV === 'production';
  const gatewayEnv = process.env.REACT_APP_GATEWAY_URI;

  if (isProd) {
    const { regionSuffix } = getShipiumDomain(window.location.hostname);
    return `https://api-gateway${regionSuffix}.${getShipiumBaseHost(window.location.hostname)}`;
  } else if (gatewayEnv) {
    return gatewayEnv;
  } else {
    return '';
  }
};

export default getGatewayUri;
